import { ApplicationConfig, DEFAULT_CURRENCY_CODE, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withHashLocation } from '@angular/router';
import { UserRepository } from '@domain/user/user.repository';
import { UserHttpRepository } from '@infrastructure/api/repositories/user-http.repository';
import { RoleRepository } from '@domain/user/role.repository';
import { RoleHttpRepository } from '@infrastructure/api/repositories/role-http.repository';
import { DispositifRepository } from '@domain/dispositif/dispositif.repository';
import { DispositifHttpRepository } from '@infrastructure/api/repositories/dispositif-http.repository';
import { ParticipantRepository } from '@domain/participant/participant.repository';
import { ParticipantHttpRepository } from '@infrastructure/api/repositories/participant-http.repository';
import { ActivityRepository } from '@domain/activity/activity.repository';
import { ActivityHttpRepository } from '@infrastructure/api/repositories/activity-http.repository';
import { LieuRepository } from '@domain/lieu/lieu.repository';
import { LieuHttpRepository } from '@infrastructure/api/repositories/lieu-http.repository';
import { SessionRepository } from '@domain/session/session.repository';
import { SessionHttpRepository } from '@infrastructure/api/repositories/session-http.repository';
import { GroupRepository } from '@domain/group/group.repository';
import { GroupHttpRepository } from '@infrastructure/api/repositories/group-http.repository';
import { importProvidersFrom } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS, withInterceptors, withInterceptorsFromDi, provideHttpClient } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { routes } from './app.routes';
import { AuthInterceptor } from '@core/interceptors/auth.interceptor';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { provideAnimations } from '@angular/platform-browser/animations';
import { httpErrorInterceptor } from '@core/interceptors/http-error.interceptor';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withHashLocation()),
    provideHttpClient(withInterceptors([httpErrorInterceptor]), withInterceptorsFromDi()),
    provideAnimations(),
    importProvidersFrom(HttpClientModule, MatSnackBarModule),
    provideAnimationsAsync(),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    { provide: UserRepository, useClass: UserHttpRepository },
    { provide: RoleRepository, useClass: RoleHttpRepository },
    { provide: DispositifRepository, useClass: DispositifHttpRepository },
    { provide: ParticipantRepository, useClass: ParticipantHttpRepository },
    { provide: ActivityRepository, useClass: ActivityHttpRepository },
    { provide: LieuRepository, useClass: LieuHttpRepository },
    { provide: SessionRepository, useClass: SessionHttpRepository },
    { provide: GroupRepository, useClass: GroupHttpRepository },
    { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'EUR' },
    provideCharts(withDefaultRegisterables()),
  ]
};
